import "./App.css";
import HomePage from "./Page/HomePage/HomePage";



function App() {
  return (
    <HomePage/>
  );
}

export default App;
